// Configuration file for tooltip texts
// This allows for easy translation to multiple languages

export const tooltipTexts = {
  en: {
    takerPrice: "= Best ask[USDT] * (1+ (taker fee [%])/100)",
    makerPrice: "=Actual Price [USDT] * (1 + Maker fee[%]/100)",
    openAsTaker: "=Best ask[USDT] * (1+ taker fee [%]/100) * volume",
    openAsMaker: "=Actual Price [USDT] * (1 + Maker fee[%]/100) * volume",
    actualPositionPnl: "For long and spot = volume * actual price * (1+taker fee) - paid for position\nFor short = paid for position - volume * actual price * (1+taker fee)\nValues in brackets use best bid for shorts and best ask for long/spot in the equation above. For opened positions, brackets show PNL at best bid/ask prices. For closed positions, brackets show the final realized PNL."
  }
  // Add more languages here as needed
  // es: {
  //   takerPrice: "Spanish translation here"
  // },
  // fr: {
  //   takerPrice: "French translation here"
  // }
};

// Default language
export const defaultLanguage = 'en';

// Helper function to get tooltip text
export const getTooltipText = (key, language = defaultLanguage) => {
  return tooltipTexts[language]?.[key] || tooltipTexts[defaultLanguage]?.[key] || '';
};
